<template>
  <div class="informatedisclosure">
    <header-view curr="5"></header-view>
    <div class="body">

	  <div class="toptitle">
	  		<div class="left_c">
				<div class="redcon"></div>
				<span>政策法规</span>
			</div>
			<div class="right_c">
				<div class="searchcon">
					 <input class="inputa" v-model="searchv" placeholder="请输入" @input="changeinput"/>
					 <img class="imgcon" src="../assets/searchimg.png" alt="" 
					 @click="changeinput"/>
				</div>
			</div>
	  </div>
	  
      <div class="centent">
		  <div class="listb">
			 <div v-for="(item, index) in list">
				  <!-- <router-link :to="'/noticeDetails?index=' + index + '&id=' + item.id"> -->
				  <div @click="toDatail(index,item)" class="signleb">
						<div class="titlecon">
							{{item.title || ''}}
						</div>
						<div class="timecon">
							{{item.createTime || ''}} 
						</div>
				  </div>
				  <!-- </router-link> -->
			 </div> 
		  </div>
		  
      </div>
	  
      <zhini-pagination
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
	  
    </div>
  </div>
</template>

<script>
import zhiniPagination from "../components/zhini-pagination.vue";
export default {
  name: "informatedisclosure",
  components: {
    zhiniPagination
  },
  data: function() {
    return {
      list: "",
      pageNo: 1,
      pageSize: 15,
      totalPage: 0,
      url: "",
	  
	  typesign:0,
	  searchv:"", 
	  
    };
  },
  created() {	  
    this.init();	
  },
  watch:{
  		$route(){
  		      this.typesign = this.$route.query.type
  		},
  	    typesign() {
  	      	this.typesign = this.$route.query.type
  			this.init()
  	    },
  },
  methods: {

    toDatail(indexsign,item){
		this.$router.push({ path: '/policiesregulationsdetail', query: {index:indexsign,id:item.id} });
	},
	
	//搜索值变化
	changeinput(){
		this.init();
	},
 
    init() {
      var that = this;
      this.httpGet("web/info/list", {
		infoType:'1',
        pageNo: this.pageNo,
        pageSize: this.pageSize,
		title:this.searchv,
      }).then(res => {
        that.list = res.result.records;
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;	
		
      this.pageNo = e;
      this.init();
    }
  },
  mounted() {}
};
</script>
<style scoped="scoped" lang="scss">
::-webkit-scrollbar {
            width: 0px;
        }
.informatedisclosure {
  // background: #f4f5f9;
  width: 100%;
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    min-height: 10rem;
	// height: 100%;
    background: #ffffff;
    margin: 2.22rem auto 0;
    padding: 0 0.7rem;
    overflow: hidden;
    .centent {
      width: 10.22rem;
      margin: 0 auto;
	  .listb{
		  max-height: 7.8rem;
		  overflow-y: auto;
		  margin-top: 0.2rem;
		  .signleb{
			  cursor: pointer;
			  height: 0.5rem;
			  display: flex;
			  align-items: center;
			  justify-content: space-between;
			  font-size: 0.16rem;
			  font-weight: bold;
			  color: #333333;
			  border-bottom: 1px solid #E6E6E6;
			  .titlecon{
				  font-size: 0.18rem;
				  font-weight: 400;
				  color: #333333;
			  }
			  .titlecon:hover {
			      color: rgba(230, 31, 38, 1);
			  }
			  .timecon{
				  font-size: 0.12rem;
				  font-weight: 400;
				  color: #999999;
			  }
		  }
	  }
	  
	 
    }
    .zhini-pagination {
	  position: absolute;
	  bottom: 0.1rem;
	  width: 100%;
	  left: 0;
    }
	
	.toptitle{
		height: 0.6rem;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 0.05rem;
				height: 0.2rem;
				background: #E70012;
				margin-right: 0.2rem;
			}
			font-size: 0.18rem;
			font-weight: 400;
			color: #E61F26;
		}
		.right_c{
			// margin-right: 0.2rem;
			.searchcon{
				height: 0.4rem;
				line-height: 0.4rem;
				width: 2.68rem;
				background: #F1F1F1;
				border-radius: 0.15rem;
				padding-left: 0.2rem;
				padding-right: 0.2rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.inputa{
					font-size: 0.14rem;
				}
				.imgcon{
					height:0.18rem;
					width: 0.18rem;
				}
			}
		}
	}
	
	
  }
}
</style>
